export default __webpack_public_path__ + "static/media/octahedron.ac9de03d.obj";